
import React, { useState } from 'react';
import { X } from 'lucide-react';
import ProfileIcon from './profiles/ProfileIcon';

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="w-full bg-black text-white py-2 px-4 text-center relative">
      <div className="flex items-center justify-center gap-2">
        <ProfileIcon platform="tiktok" size="sm" />
        <span className="font-medium">Get your TikTok agency ad account for free</span>
      </div>
      <button 
        onClick={() => setIsVisible(false)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
        aria-label="Close announcement"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
